<template>
    <!-- 广告商务合作,预约咨询 -->
    <div class="marketing-index-footer footer">
        <!-- 底部内容 S -->
        <div class="marketing-footer-con" >
            <!-- 标题部分 S -->
            <div class="marketing-footer-head">
                <div class="title-icon"/>
                <h6 class="marketing-footer-title">无论有什么需求，留下您的联系方式</h6>
                <h6 class="marketing-footer-title">我们的营销团队将为您提供专业解决方案</h6>
            </div>
            <!-- 标题部分 E -->

            <!-- 预约咨询输入框 S -->
            <div
                class="marketing-index-form cls flex_layout flex_wrap flex_x_spacebetween"
                @click.stop="()=>{ return false;}">
                <div class="input-box">
                    <p>公司名称</p>
                    <input
                        v-model="form.company_name"
                        placeholder="必填，50字以内"
                        @input.stop="onInput"
                        @keydown.stop="onInput"
                        @focus.stop="onInput"
                    >
                    <div v-show="!!errorInfo.company_name" class="error-text">{{errorInfo.company_name}}</div>
                </div>
                <div class="input-box">
                    <p>姓名</p>
                    <input
                        v-model="form.name"
                        placeholder="必填，20字以内"
                        @input.stop="onInput"
                        @keydown.stop="onInput"
                        @focus.stop="onInput"
                    >
                    <div v-show="!!errorInfo.name" class="error-text">{{errorInfo.name}}</div>
                </div>
                <div class="input-box">
                    <p>手机号码</p>
                    <input
                        v-model="form.tel"
                        placeholder="必填，11个数字"
                        @input.stop="onInput"
                        @keydown.stop="onInput"
                        @focus.stop="onInput"
                    >
                    <div v-show="!!errorInfo.tel" class="error-text">{{errorInfo.tel}}</div>
                </div>
                <div
                    class="input-box"
                    style="margin-right:0">
                    <p>邮箱</p>
                    <input
                        v-model="form.email"
                        placeholder="必填，50字以内"
                        @input.stop="onInput"
                        @keydown.stop="onInput"
                        @focus.stop="onInput"
                    >
                    <div v-show="!!errorInfo.email" class="error-text">{{errorInfo.email}}</div>
                </div>
                <div class="input-box">
                    <p>行业</p>
                    <input
                        v-model="form.industry"
                        placeholder="必填，20字以内"
                        @input.stop="onInput"
                        @keydown.stop="onInput"
                        @focus.stop="onInput"
                    >
                    <div v-show="!!errorInfo.industry" class="error-text">{{errorInfo.industry}}</div>
                </div>
                <div class="input-box">
                    <p>产品名称</p>
                    <input
                        v-model="form.product_name"
                        placeholder="必填，20字以内"
                        @input.stop="onInput"
                        @keydown.stop="onInput"
                        @focus.stop="onInput"
                    >
                    <div v-show="!!errorInfo.product_name" class="error-text">{{errorInfo.product_name}}</div>
                </div>
                <div class="input-box longinput">
                    <p>产品信息</p>
                    <input
                        v-model="form.product_info"
                        placeholder="非必填，可填写产品链接"
                        @input.stop="onInput"
                        @keydown.stop="onInput"
                        @focus.stop="onInput"
                    >
                    <div v-show="!!errorInfo.product_info" class="error-text">{{errorInfo.product_info}}</div>
                </div>
                <div class="input-box" style="width:100%;">
                    <p>意向图形</p>
                    <div class="txtarea flex_layout flex_wrap flex_x_spacebetween">
                        <template v-for="(item, index) in form.ip_pic_reserved" >
                            <div class="item flex_layout flex_x_spacebetween">
                                <div class="popimg flex_xy_center">
                                    <div class="popimg-img">
                                        <img :data-src="item.display_cover_pic ? _dealImageSuffix({value: item.display_cover_pic, width: 200}) : ''" v-lazyLoad/>
                                    </div>
                                </div>
                                <div class="item-name">{{item.cover_pic_name}}</div>
                                <div @click="clickDelete(item.id)" class="item-close flexitem_flexshrink_0 flex_xy_center"><div class="ic_close"></div></div>
                            </div>
                        </template>
                        <div v-if="form.ip_pic_reserved.length" @click="clickClear()" class="item flex_xy_center" style="background: white;">
                            <div class="clear flex_xy_center">清空全部</div>
                        </div>
                        <div class="item" style="height:0;margin:0;"></div>
                        <div class="item" style="height:0;margin:0;"></div>
                        <div class="item" style="height:0;margin:0;"></div>
                        <div class="item" style="height:0;margin:0;"></div>
                        <div class="item" style="height:0;margin:0;"></div>
                    </div>
                </div>
            </div>
            <!-- 预约咨询输入框 E -->
            <div @click.stop="handleSubmitClick" class="btn_hezuo">
                <img src="../img/btn_yuyue@2x.png" alt="pic"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { toast } from '@kkmh/utils';

export default {
    name: 'compFooter',
    data () {
        return {
            form: {
                name: '',
                company_name: '',
                industry: '',
                tel: '',
                source: 1, // 默认传1，区分别营销合作页面的留资
                email: '', //邮箱
                product_name: '', //产品名称
                product_info: '', //产品信息
                ip_pic_reserved: [], //意向选择列表
            },
            errorInfo: {
                name: '',
                company_name: '',
                industry: '',
                tel: '',
                email: '',
                product_name: '',
                product_info: '',
            },
        };
    },
    computed: {
        ...mapState(['iplist']),
    },
    watch: {
        iplist (val) {
            this.form.ip_pic_reserved = Array.from(this.iplist).map(item => {
                return item[1];
            });
        }
    },
    created () {
        let iplist;
        try {
            iplist = new Map(JSON.parse(localStorage.getItem('iplist')));
        } catch (error) {
            iplist = new Map();
        }
        // console.log('footer', iplist);
        this.setIpList(iplist);
    },
    methods: {
        ...mapMutations(['setIpList']),
        clickClear () {
            this.setIpList(new Map());
            localStorage.removeItem('iplist');
        },
        clickDelete (id) {
            let iplist = new Map(this.iplist);
            iplist.delete(id);
            this.setIpList(iplist);
            localStorage.setItem('iplist', JSON.stringify(Array.from(iplist)));
        },
        handleSubmitClick () {
          if (this.validateForm()) {
            this.submitForm();
          }
        },
        /** 校验表单内容, 如果校验不通过, 则抛错 */
        validateForm () {
          const { form, errorInfo } = this;
          /** 手机号正则 */
          const telephoneNumber = /^([1][3,4,5,6,7,8,9])\d{9}$/;
          // const emailpattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
          const emailpattern = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;

          this.resetErrorInfo();
          // company_name, 必填 50 字内
          if (!form.company_name) {
            errorInfo.company_name = '此项必填';
          } else if (form.company_name.length > 50) {
            errorInfo.company_name = '字数超过限制, 需 50 字内';
          }

          // name, 必填 20 字内
          if (!form.name) {
            errorInfo.name = '此项必填';
          } else if (form.name.length > 20) {
            errorInfo.name = '字数超过限制, 需 20 字内';
          }

          if (!telephoneNumber.test(form.tel)) {
            errorInfo.tel = '格式错误, 需填写 11 位手机号';
          }

          if (!emailpattern.test(form.email)) {
            errorInfo.email = '格式错误, 需填写正确的邮箱';
          }

          // industry, 行业必填 20 字内
          if (!form.industry) {
            errorInfo.industry = '此项必填';
          } else if (form.industry.length > 20) {
            errorInfo.industry = '字数超过限制, 需 20 字内';
          }

          // product_name, 产品名称必填 20 字内
          if (!form.product_name) {
            errorInfo.product_name = '此项必填';
          } else if (form.product_name.length > 20) {
            errorInfo.product_name = '字数超过限制, 需 20 字内';
          }

          // 清空错误信息
          if (Object.keys(this.errorInfo).some(key => (!!this.errorInfo[key]))) {
            return false;
          }
          return true;
        },
        resetErrorInfo () {
          // 清空错误信息
          Object.keys(this.errorInfo).forEach((key) => {
            this.errorInfo[key] = '';
          });
        },
        resetForm () {
          // 清空表单数据
          Object.keys(this.form).forEach((key) => {
            if (key !== 'ip_pic_reserved') {
              this.form[key] = '';
            }
          });
        },
        async submitForm () {
          if (this.lock) {
            return;
          }
          this.lock = true;
          try {
            await request({
                type: 'post',
                url: '/v3/ad/h5/marketing_case/customer/add',
                headers: {
                  'Content-Type': 'application/json'
                },
                data: {
                  ...this.form,
                  ip_pic_reserved: (this.form.ip_pic_reserved || []).map((item) => {
                    return {
                        id: item.id,
                        cover_pic_name: item.cover_pic_name,
                        ip_name: item.ip_name,
                        display_cover_pic: item.display_cover_pic,
                    };
                  }),
                  source: 3,
                },
            });
            toast('预约成功');
            this.resetForm();
            this.clickClear();
          } catch (err) {
            toast(`信息保存失败：${error}`);
          }
          this.lock = false;
        },

        //阻止默认事件
        onInput () {
            return false;
        },
    }
};
</script>

<style lang='scss' scoped>
@import "@/css/common.scss";
.error-text {
    font-size: 14px;
    color: #E04545;
    position: absolute;
}
.ic_close {
    width:10px;
    height:10px;
    background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgEAYAAAAj6qa3AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAQhJREFUaN7tmEsShCAMRHGOI27Eq2i50PtfQis9C2ThyKg1FQiM9IaFWOl+fpJCqaKioqIbAgCg60AgUNNI+zn423xZn8bwBwcAENl1Wew6juLBNx97X85n2zIV0HpfwEkOhD/4p6+65itIIFDf+wuuq70+z8GDEwg0DF99AACmKbCB+CDEg0uBSC54LBDJBw8FIrvgXCCyD/4riL8LfgAB4LpfpzNfhANx+kbIPfFXXAxVdU1KQeHGvlz02E/g7s8tlRE7enD/fRmD4Gpn2YEI1ceTBxFrgEkOhNTkJg4ilZE1Ooj9YWM6/drVPfelNVMhY+z6wENRPwgGskFAuMNbxuBFRUV/rTdLIvSbTZtuvgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wNy0xMVQxMTo1NzowMiswODowMMAFyOUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDctMTFUMTE6NTc6MDIrMDg6MDCxWHBZAAAATnRFWHRzdmc6YmFzZS11cmkAZmlsZTovLy9ob21lL2FkbWluL2ljb24tZm9udC90bXAvaWNvbl9mMnh6amIxeGJ4Zy95dXlpbmd1YW5iaS5zdmcz0tvhAAAAAElFTkSuQmCC) no-repeat;
    background-size:contain;
}
.txtarea{
    padding:16px 16px 0;
    border: 1px solid #000;
    width: 100%;
    min-height: 148px;
    border-radius: 10px;
    padding: 16px;
    background: #fff;
    font-size: 16px;
    .item{
        position: relative;
        width: 184px;
        height: 28px;
        background: rgb(229, 229, 229);
        border-radius: 4px;
        margin-bottom: 16px;
        .item-name{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: rgb(30, 30, 30);
            line-height: 28px;
            width: 100%;
        }
        .item-close{
            width: 20px;
            height: 100%;
            background: rgb(177, 177, 177);
            font-size: 12px;
            color: white;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
        .clear{
            padding-bottom:3px;
            font-size: 12px;
            font-weight: 400;
            color: rgb(30, 30, 30);
            width:119px;
            height:30px;
            background:url(../img/clear@2x.png) no-repeat;
            background-size:contain;
        }
        .popimg{
            opacity:0;
            position:absolute;
            top:-57px;
            left:50%;
            transform: translateX(-50%);
            width:50px;
            height:50px;
            background: #FFE120;
            border-radius: 4px;
            .popimg-img{
                width:44px;
                height:44px;
                border-radius: 4px;
                overflow: hidden;
            }
        }
        .popimg:after{
            content: "";
            display: inline-block;
            width: 0;
            height: 0;
            border: 5px solid transparent;
            border-top: 5px solid #ffe120;
            position: absolute;
            left: 50%;
            bottom: -9px;
            transform: translateX(-50%);
        }
    }
    .item:hover{
        .popimg{
            opacity:1;
        }
    }
}
.marketing-index-footer{
    padding-bottom: 92px;
    width: 100%;
    background: #d8d8d8;
    //底部内容部分
    .marketing-footer-con{
        margin: 0 auto;
        width: 1184px;
        height: auto;
    }
    .marketing-footer-head{
        padding-top: 40px;
        .title-icon{
            margin: 0 auto 20px;
            width: 22px;
            height: 7px;
            background: #1E1E1E;
        }
        .marketing-footer-title{
            font-size: 26px;
            text-align: center;
            color: #1E1E1E;
            font-weight:bold;
        }
    }

    .marketing-index-form{
        padding-top: 32px;
        width:100%;
        p{
            padding-bottom: 8px;
            font-size: 18px;
            color: #1E1E1E;
        }
        .input-box{
            width: 281px;
            margin-bottom: 30px;
            input{
                display: block;
                border: 1px solid #000;
                width: 100%;
                height: 50px;
                border-radius: 10px;
                padding: 16px;
                background: #fff;
                outline-style: none;
                outline-width: 0;
                font-size: 16px;
            }
        }
        .longinput{
            width:582px;
        }

    };
    .btn_hezuo{
        cursor:pointer;
        font-size:0;
        margin: 56px auto;
        width: 292px;
        height: 77px;
    }
}

@media (max-width:1184px) {
    .error-text {
        font-size: 12px;
    }
    .txtarea{
        .item{
            width: 140px;
        }
    }
    .marketing-index-footer{
        padding-bottom: 20px;
        .marketing-footer-con{
            width: 100%;
        }
        .marketing-footer-head{
            padding-top: 25px;
            .title-icon{
                display:none;
            }
            .marketing-footer-title{
                font-size: 14px;
            }
        }
        .marketing-index-form{
            padding: 20px 20px 0;
            width:100%;
            p{
                padding-bottom: 8px;
                font-size: 13px;
                color: #1E1E1E;
            }
            .input-box{
                width: 100%;
                margin-bottom: 20px;
                input{
                    height: 36px;
                    border-radius: 5px;
                    padding: 10px 15px;
                    font-size: 13px;
                }
            }
            .longinput{
                width:100%;
            }
        }
        .btn_hezuo{
            margin: 0 auto 20px;
            width: 146px;
            height: 77px;
        }
    }
}

</style>